import { createSlice } from '@reduxjs/toolkit';

import { dispatch } from '../index';
import {API} from "aws-amplify";

const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_get_contact_details = process.env.REACT_APP_DASHBOARD_GET_CONTACT;

const initialState = {
    contact: {},
    contact_error: null
};

const contact = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        hasError(state, action){
            state.contact_error = action.payload.contact_error;
        },
        getContactSuccess(state, action){
            state.contact = action.payload.data.contact;
            state.contact_error = action.payload.data.contact_error
        }
    }
})

export default contact.reducer;

export function getContactDetails(username, subscription_id, contactId){
    return async() => {
        var myInit = {};
        myInit = {
            headers: {},
            response: true,
            queryStringParameters: {
                "username": JSON.stringify(username),
                "subscription_id": subscription_id,
                "contactId": contactId
            }
        }
        API.get(apiName, path_get_contact_details, myInit)
            .then(response => {
                dispatch(contact.actions.getContactSuccess(response.data))
            }).catch(error => {
                dispatch(contact.actions.hasError(error))
        })
    };
}